// Tree-shaking de Vuetify: en lugar de `import * as components` (que empaqueta
// TODA la librería en chunk-vendors), importamos SOLO los componentes que se usan
// en los templates. Webpack descarta el resto. Lista derivada de los tags <v-*>
// presentes en src/**/*.vue — si agregás un componente Vuetify nuevo, registralo aquí.
import { createVuetify } from 'vuetify'
import {
  VAlert,
  VApp,
  VAppBar,
  VAppBarNavIcon,
  VAutocomplete,
  VAvatar,
  VBadge,
  VBtn,
  VBtnToggle,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VCheckbox,
  VCheckboxBtn,
  VChip,
  VCol,
  VContainer,
  VDivider,
  VDialog,
  VExpandTransition,
  VForm,
  VIcon,
  VList,
  VListItem,
  VListItemSubtitle,
  VListItemTitle,
  VListSubheader,
  VMain,
  VMenu,
  VNavigationDrawer,
  VPagination,
  VProgressCircular,
  VProgressLinear,
  VRow,
  VSelect,
  VSheet,
  VSnackbar,
  VSpacer,
  VSwitch,
  VTab,
  VTabs,
  VTextField,
  VTextarea,
  VToolbarTitle,
  VTooltip,
  VWindow,
  VWindowItem,
} from 'vuetify/components'
import { VDataTable, VDataTableServer } from 'vuetify/components/VDataTable'
import { VDatePicker } from 'vuetify/components/VDatePicker'
import { es } from 'vuetify/locale'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import {
  DEFAULT_APPEARANCE_PRESET_ID,
  deriveBrandThemeTokens,
  getAppearancePresetById,
} from '@/utils/appearanceTheme'

const defaultBrandTokens = deriveBrandThemeTokens(
  getAppearancePresetById(DEFAULT_APPEARANCE_PRESET_ID)
)

export default createVuetify({
  components: {
    VAlert,
    VApp,
    VAppBar,
    VAppBarNavIcon,
    VAutocomplete,
    VAvatar,
    VBadge,
    VBtn,
    VBtnToggle,
    VCard,
    VCardActions,
    VCardText,
    VCardTitle,
    VCheckbox,
    VCheckboxBtn,
    VChip,
    VCol,
    VContainer,
    VDataTable,
    VDataTableServer,
    VDatePicker,
    VDivider,
    VDialog,
    VExpandTransition,
    VForm,
    VIcon,
    VList,
    VListItem,
    VListItemSubtitle,
    VListItemTitle,
    VListSubheader,
    VMain,
    VMenu,
    VNavigationDrawer,
    VPagination,
    VProgressCircular,
    VProgressLinear,
    VRow,
    VSelect,
    VSheet,
    VSnackbar,
    VSpacer,
    VSwitch,
    VTab,
    VTabs,
    VTextField,
    VTextarea,
    VToolbarTitle,
    VTooltip,
    VWindow,
    VWindowItem,
  },
  locale: {
    locale: 'es',
    fallback: 'en',
    messages: { es },
  },
  date: {
    locale: {
      es: 'es-ES',
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          background: '#f7f4ec',
          surface: '#fffdf8',
          primary: defaultBrandTokens.primary,
          secondary: defaultBrandTokens.sidebar,
          accent: defaultBrandTokens.accent,
          error: '#b64a35',
          info: '#3f6f8f',
          success: '#3f8f62',
          warning: '#d3a83f',
          active: defaultBrandTokens.active,
          inactive: '#737a70',
          pending: '#c2872e',
          draft: '#697886',
          'on-background': '#243126',
          'on-surface': '#243126',
        },
      },
    },
  },
  defaults: {
    VBtn: {
      variant: 'flat',
      rounded: 'pill',
      color: 'primary',
    },
    VCard: {
      color: 'surface',
      rounded: 'xl',
      elevation: 0,
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
      hideDetails: 'auto',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
      hideDetails: 'auto',
    },
    VAutocomplete: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
      hideDetails: 'auto',
    },
    VTextarea: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
      hideDetails: 'auto',
    },
    VChip: {
      rounded: 'pill',
    },
    VDialog: {
      scrim: 'rgba(23, 40, 29, 0.28)',
    },
  },
})
